wbApp.factory('reservationsSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {

        var Reservation = $resource('/restapi/reservations/:id', {}, {
            'insert': { method: 'POST', url: '/restapi/reservations' },
            'update': { method: 'PUT', url: '/restapi/reservations/:id' },
            'delete': { method: 'DELETE', url: '/restapi/reservations/:id' },
            'getAllByRangeAndPlace': { method: 'GET', isArray: true, url: '/restapi/reservations/range/find-by-place' },
            'getAllByRangeAndUser': { method: 'GET', isArray: true, url: '/restapi/reservations/range/find-by-user' },
            'getAllByRangeAndStudent': { method: 'GET', isArray: true, url: '/restapi/reservations/range/find-by-student' },
            'getByInvoice': { method: 'GET', isArray: false, url: '/restapi/reservations/find-by-invoice' }
        });

        function insert(model) {
            lastLoadedRangeAndPlace = null;

            return repositorySvc.customPost(
                'insert',
                Reservation,
                model);
        }

        function remove(reservationId) {
            lastLoadedRangeAndPlace = null;

            return repositorySvc.customDelete(
                'delete',
                Reservation,
                { id: reservationId });
        }

        function update(model) {
            lastLoadedRangeAndPlace = null;

            return repositorySvc.customPutWithParams(
                'update',
                Reservation,
                { id: model.id },
                model);
        }

        function getAllByRangeAndUser(userId, fromDate, toDate, employees) {
            return $q(function (resolve, reject) {
                var getResult = repositorySvc.customGet(
                    'getAllByRangeAndUser',
                    Reservation,
                    {
                        userId: userId,
                        from: fromDate,
                        to: toDate
                    });

                getResult.$promise.then(
                    function (data) {
                        resolve(_.map(data, function (r) {

                            var employee = _.find(employees, { id: r.employeeId });

                            return {
                                startDate: r.reservationStartDate,
                                endDate: r.reservationEndDate,
                                placeId: r.placeId,
                                teacherName: !!employee
                                    ? employee.fullName
                                    : '',
                                filledCapacity: r.studentIds.length + '',
                                subject: r.domain.name
                            }
                        }));
                    },
                    function (error) {
                        reject(error);
                    });
            });
        }

        var lastLoadedRangeAndPlace = null;
        var lastLoadedRangeAndPlaceFilter = {
            placeId: null,
            fromDate: null,
            toDate: null
        };

        function getAllByRangeAndPlace(placeId, fromDate, toDate) 
        {
            var mnow = moment();

            if (!lastLoadedRangeAndPlace ||
                lastLoadedRangeAndPlaceFilter.placeId != placeId ||
                !moment(lastLoadedRangeAndPlaceFilter.fromDate).isSame(fromDate) ||
                !moment(lastLoadedRangeAndPlaceFilter.toDate).isSame(toDate) ||
                lastLoadedRangeAndPlaceFilter.loadedAt.isBefore(mnow)) {

                lastLoadedRangeAndPlaceFilter = {
                    placeId: placeId,
                    fromDate: fromDate,
                    toDate: toDate,
                    loadedAt: moment().add(10, 'seconds')
                };

                lastLoadedRangeAndPlace = $q(function (resolve, reject) {
                    var getResult = repositorySvc.customGet(
                        'getAllByRangeAndPlace',
                        Reservation,
                        {
                            expanded: 'Students,Invoices',
                            placeId: placeId,
                            from: fromDate,
                            to: toDate
                        });

                    getResult.$promise.then(
                        function (data) {
                            resolve(data);
                        },
                        function (error) {
                            reject(error);
                        });
                });
            }

            return lastLoadedRangeAndPlace;
        }

        function getAllByRangeAndStudent(studentId, fromDate, toDate) {
            return $q(function (resolve, reject) {
                var getResult = repositorySvc.customGet(
                    'getAllByRangeAndStudent',
                    Reservation,
                    {
                        expanded: 'Invoices',
                        studentId: studentId,
                        from: fromDate,
                        to: toDate
                    });

                getResult.$promise.then(
                    function (data) {
                        resolve(data);
                    },
                    function (error) {
                        reject(error);
                    });
            });
        }

        function getByInvoice(invoiceId)
        {
            return $q(function (resolve, reject) {
                var getResult = repositorySvc.customGet(
                    'getByInvoice',
                    Reservation,
                    {
                        expanded: 'Invoices',
                        invoiceId: invoiceId
                    });

                getResult.$promise.then(
                    function (data) {
                        resolve(data);
                    },
                    function (error) {
                        reject(error);
                    });
            });

        }

        return {
            insert: insert,
            remove: remove,
            update: update,
            getAllByRangeAndUser: getAllByRangeAndUser,
            getAllByRangeAndPlace: getAllByRangeAndPlace,
            getAllByRangeAndStudent: getAllByRangeAndStudent,
            getByInvoice: getByInvoice
        }
    }]);
